export const writeReviewValidationConfig = {
  rating: {
    isRequired: true,
    label: 'Rating',
  },
  text: {
    isRequired: false,
    label: 'Text',
    maxLength: 500,
  },
};

export const REVIEW_RATINGS = [1, 2, 3, 4, 5];
